module.exports = __webpack_public_path__ + "static/media/bg.dbf27d3a.png";